import { Form } from "antd"
import { Checkbox, Text } from "components/common"
import { t } from "i18next"
const RACheckbox = ({ listFieldName, fieldName = "enableRA", getAccountant, ...restField }) => (
  <Form.Item {...restField} preserve name={[listFieldName, fieldName]} valuePropName="checked">
    <Checkbox
      onChange={e => {
        if (e?.target?.checked) getAccountant(null, true)
      }}
    >
      <Text className="gray-900">{t("Cash Submitted by RA")}</Text>
    </Checkbox>
  </Form.Item>
)

export default RACheckbox
